import React from 'react';
import './statisticCounter.scss';

const StatisticCounter = ({ firstBg, secondBg, todayCount, todayText, yesterdayCount, yesterdayText, weekCount, weekText, image }) => {
    return (
        <div className="statistic-counter" style={{ background: `linear-gradient(90deg, ${firstBg}, ${secondBg})` }}>
            <div className="statistic-counter__today">
                <img src={image} alt='mySvgImage' className='statistic-counter__today-iamge' />
                <div className="statistic-counter__today-item">
                    <div className="statistic-counter__today-item-count">{todayCount}</div>
                    <div className="statistic-counter__today-item-text">{todayText}</div>
                </div>
            </div>
            <div className="statistic-counter__yesterday">
                <div className="statistic-counter__yesterday-text">{yesterdayText}</div>
                <div className="statistic-counter__yesterday-count">{yesterdayCount}</div>
            </div>
            <div className="statistic-counter__week">
                <div className="statistic-counter__week-text">{weekText}</div>
                <div className="statistic-counter__week-count">{weekCount}</div>
            </div>
        </div>
    );
};

export default StatisticCounter;